<template>
  <div class="tags-wrapper">
    <div class="tagsbox">
      <div
        :class="isActive(item.url) ? 'active' : ''"
        class="tagsview"
        v-for="(item, index) in tags"
        :key="item.name || index"
        @click="tagsmenu(item)"
        @contextmenu.prevent.stop="openMenu(item, $event)"
      >
        {{ item.meta && item.meta.title ? item.meta.title : item.name }}
        <span
          v-if="!(item.meta && item.meta.affix)"
          class="el-icon-close tagsicon"
          @click.stop="handleClose(item, index)"
        ></span>
      </div>
    </div>
    <ul
      v-show="visible"
      ref="contextMenu"
      class="tags-contextmenu"
      :style="{ left: left + 'px', top: top + 'px' }"
      @click.stop
      @contextmenu.prevent.stop
    >
      <li v-if="!(selectedTag && selectedTag.meta && selectedTag.meta.affix)" @click.stop="closeSelectedTag">关闭</li>
      <li @click.stop="closeOtherTags">关闭其他</li>
      <li @click.stop="closeAllTags">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: null,
    };
  },
  computed: {
    ...mapState(["tags"]),
  },
  beforeDestroy() {
    this.removeDocumentListener();
  },
  methods: {
    ...mapMutations(["closeTab", "closeOtherTabs", "closeAllTabs"]),
    openMenu(tag, e) {
      this.selectedTag = tag;
      this.left = e.clientX;
      this.top = e.clientY;
      this.visible = true;
      this.removeDocumentListener();
      this.$nextTick(() => {
        this.adjustMenuPosition();
        document.addEventListener("click", this.handleDocumentClose);
        document.addEventListener("scroll", this.handleDocumentClose, true);
      });
    },
    adjustMenuPosition() {
      const menu = this.$refs.contextMenu;
      if (!menu) {
        return;
      }
      const rect = menu.getBoundingClientRect();
      const padding = 8;
      let nextLeft = this.left;
      let nextTop = this.top;
      if (rect.right > window.innerWidth - padding) {
        nextLeft = window.innerWidth - rect.width - padding;
      }
      if (rect.bottom > window.innerHeight - padding) {
        nextTop = window.innerHeight - rect.height - padding;
      }
      if (nextLeft < padding) {
        nextLeft = padding;
      }
      if (nextTop < padding) {
        nextTop = padding;
      }
      this.left = nextLeft;
      this.top = nextTop;
    },
    handleDocumentClose(e) {
      const menu = this.$refs.contextMenu;
      if (menu && menu.contains(e.target)) {
        return;
      }
      this.closeMenu();
    },
    closeMenu() {
      this.visible = false;
      this.removeDocumentListener();
    },
    removeDocumentListener() {
      document.removeEventListener("click", this.handleDocumentClose);
      document.removeEventListener("scroll", this.handleDocumentClose, true);
    },
    emitDeleteQuery(items) {
      items.forEach((item) => {
        this.$emit("refreshDeleteQuery", item);
      });
    },
    navigateAfterClose(targetPath) {
      if (targetPath && this.$route.path !== targetPath) {
        this.$router.push({ path: targetPath });
      }
    },
    handleClose(item, index) {
      if (item && item.meta && item.meta.affix) {
        return;
      }
      this.$emit("refreshDeleteQuery", item);
      const length = this.tags.length - 1;
      this.closeTab(item);
      if (item.url !== this.$route.path) {
        return;
      }
      if (index === length) {
        if (length === 0) {
          if (this.$route.path !== "/welcome") {
            this.$router.push({ path: "/welcome" });
          }
        } else {
          this.$router.push({ path: this.tags[index - 1].url });
        }
      } else {
        this.$router.push({ path: this.tags[index].url });
      }
    },
    closeSelectedTag() {
      if (!this.selectedTag) {
        return;
      }
      const index = this.tags.findIndex((item) => item.name === this.selectedTag.name);
      if (index !== -1) {
        this.handleClose(this.selectedTag, index);
      }
      this.closeMenu();
    },
    closeOtherTags() {
      if (!this.selectedTag) {
        return;
      }
      const keep = this.selectedTag;
      const toRemove = this.tags.filter((item) => item.name !== keep.name);
      this.emitDeleteQuery(toRemove);
      this.closeOtherTabs(keep);
      this.navigateAfterClose(keep.url);
      this.closeMenu();
    },
    closeAllTags() {
      const toRemove = [...this.tags];
      this.emitDeleteQuery(toRemove);
      this.closeAllTabs();
      this.navigateAfterClose("/welcome");
      this.closeMenu();
    },
    tagsmenu(item) {
      this.closeMenu();
      this.$emit("refreshAddQuery", item);
      if (this.$route.path !== item.url) {
        this.$router.push({ path: item.url });
      }
    },
    isActive(route) {
      return route === this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-wrapper {
  position: relative;
  width: 100%;
}
.tagsbox {
  margin-left: 40px;
  width: calc(100% - 100px);
  overflow-x: auto;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
  &::-moz-scrollbar {
    display: none;
  }
  &::-ms-scrollbar {
    display: none;
  }
}
.tagsview {
  cursor: pointer;
  margin-left: 5px;
  height: 30px;
  line-height: 30px;
  padding: 0 8px;
  border: 1px solid #d8dce5;
  border-radius: 5px;
  color: #000;
  font-size: 14px;
  display: inline-block;
  user-select: none;
}
.tagsicon:hover {
  color: #f56c6c;
}
.active {
  border: 1px solid var(--theme-primary, #409eff);
  color: var(--theme-primary, #409eff);
  font-weight: bold;
}
</style>

<style lang="scss">
.tags-contextmenu {
  margin: 0;
  background: #fff;
  z-index: 9999;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e4e7ed;
  min-width: 110px;
}
.tags-contextmenu li {
  margin: 0;
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
}
.tags-contextmenu li:hover {
  background: #f5f7fa;
  color: var(--theme-primary, #409eff);
}
</style>
